import { createSlice } from "@reduxjs/toolkit";
import { minPercentageOnWinOrLoss } from "../../config";
const betAmountDefaultValue = 1;
const minesAmountDefaultValue = 3;
const autoBetsNumberOfRoundsDefaultValue = 10;
const onWinPercentageDefaultValue = minPercentageOnWinOrLoss;
const onLossPercentageDefaultValue = minPercentageOnWinOrLoss;
const onWinStopDefaultValue = 0;
const onLossStopDefaultValue = 0;

export const gameSettingsSlice = createSlice({
  name: "gameSettings",
  initialState: {
    betAmount: betAmountDefaultValue,
    minesAmount: minesAmountDefaultValue,
    isInManualMode: true,
    autoBetsNumberOfRounds: autoBetsNumberOfRoundsDefaultValue,
    autoBetsCurrentNumberOfRounds: autoBetsNumberOfRoundsDefaultValue,
    selectedTiles: [],
    isOnWinReset: true,
    onWinPercentage: onWinPercentageDefaultValue,
    isOnLossReset: true,
    onLossPercentage: onLossPercentageDefaultValue,
    onWinStopValue: onWinStopDefaultValue,
    onLossStopValue: onLossStopDefaultValue,
  },
  reducers: {
    changeBetAmount: (state, action) => {
      state.betAmount = action.payload;
    },
    changeMinesAmount: (state, action) => {
      state.minesAmount = action.payload;
    },
    changeAutoBetsNumberOfRounds: (state, action) => {
      state.autoBetsNumberOfRounds = action.payload;
    },
    changeAutoBetsCurrentNumberOfRounds: (state, action) => {
      state.autoBetsCurrentNumberOfRounds = action.payload;
    },
    changeIsInManualMode: (state, action) => {
      localStorage.setItem("IsInManualMode", !state.isInManualMode);
      state.isInManualMode = !state.isInManualMode;
    },
    setIsInManualMode: (state, action) => {
      localStorage.setItem("IsInManualMode", action.payload);
      state.isInManualMode = action.payload;
    },
    changeOnWinPercentage: (state, action) => {
      state.onWinPercentage = action.payload;
    },
    changeIsOnWinReset: (state, action) => {
      state.isOnWinReset = action.payload;
    },
    changeOnLossPercentage: (state, action) => {
      state.onLossPercentage = action.payload;
    },
    changeIsOnLossReset: (state, action) => {
      state.isOnLossReset = action.payload;
    },
    changeSelectedTile: (state, action) => {
      const arr = [...state.selectedTiles];
      const index = arr.indexOf(action.payload);
      if (index !== null && index !== undefined && index >= 0) {
        //already exist-delete
        arr.splice(index, 1);
        localStorage.setItem("selectedTiles", arr);
        state.selectedTiles = arr;
      } else {
        localStorage.setItem("selectedTiles", [
          ...state.selectedTiles,
          action.payload,
        ]);

        state.selectedTiles = [...state.selectedTiles, action.payload];
      }
    },
    setSelectedTile: (state, action) => {
      localStorage.setItem("selectedTiles", action.payload);
      state.selectedTiles = action.payload;
    },

    changeOnWinStopValue: (state, action) => {
      state.onWinStopValue = action.payload;
    },
    changeOnLossStopValue: (state, action) => {
      state.onLossStopValue = action.payload;
    },
    reset: (state) => {
      state.betAmount = betAmountDefaultValue;
      state.minesAmount = minesAmountDefaultValue;
      state.isInManualMode = true;
      state.selectedTiles = [];
      state.autoBetsNumberOfRounds = autoBetsNumberOfRoundsDefaultValue;
      state.onLossPercentage = onLossPercentageDefaultValue;
      state.isOnLossReset = true;
      state.onWinPercentage = onWinPercentageDefaultValue;
      state.isOnWinReset = true;
      state.onWinStopValue = 0;
      state.onLossStopValue = 0;
    },
  },
});

export const {
  changeBetAmount,
  changeMinesAmount,
  // reset,
  changeIsInManualMode,
  setIsInManualMode,
  changeSelectedTile,
  changeAutoBetsNumberOfRounds,
  changeAutoBetsCurrentNumberOfRounds,
  changeOnWinPercentage,
  changeOnLossPercentage,
  changeIsOnWinReset,
  changeIsOnLossReset,
  setSelectedTile,
  changeOnWinStopValue,
  changeOnLossStopValue,
} = gameSettingsSlice.actions;

export default gameSettingsSlice.reducer;
